import { Link } from "react-router-dom";
const AccountSettingTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item" role="presentation">
        <Link
          to={"/customers"}
          className={
            props.pageName === "CUSTOMER"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CUSTOMER
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/vendors"}
          className={
            props.pageName === "VENDOR"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          VENDOR
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/bankaccounts"}
          className={
            props.pageName === "BANKACCOUNT"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          BANK ACCOUNT
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/taxrates"}
          className={
            props.pageName === "TAXRATE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          TAX RATE
        </Link>
      </li>
      {/* <li className="nav-item" role="presentation">
        <Link
          to={"/exchangerates"}
          className={
            props.pageName === "EXCHANGERATE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          EXCHANGE RATE
        </Link>
      </li> */}
    </ul>
  );
};

export default AccountSettingTabs;
